import React, { memo } from 'react'
import { useUserIdentityFn } from '@plvs/client-data/hooks'
import { Box } from '@plvs/respawn/features/layout'
import { makeStyles, useTheme } from '@material-ui/core'
import clsx from 'clsx'
import { Path, SponsorshipImageName } from '@plvs/const'
import * as analytics from '@plvs/respawn/features/analytics'
import dayjs from '@plvs/respawn/init/dayjs'
import { useNavigate } from 'react-router-dom'
import { MUIThemeModeEnum } from '@playvs-inc/nexus-theme'
import { useProductTours } from '@plvs/respawn/features/shepherd/utils/useProductTours'
import { OrgTypeLogo } from '@plvs/respawn/components/logo/OrgTypeLogo'

const useStyles = makeStyles((theme) => ({
  dashNav: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  campaignLogo: {
    maxHeight: 126,
    maxWidth: 240,
  },
}))

export const AppDrawerLogo: React.FC = memo(() => {
  const theme = useTheme()
  const isDarkMode = theme.palette.type === MUIThemeModeEnum.Dark

  const navigate = useNavigate()
  const classes = useStyles()

  const { userId, activeCampaign, orgCompetitionGroup } = useUserIdentityFn()
  const { onboardingTour, initiatedTimestamp } = useProductTours()

  const navigateToDashboard = (): void => {
    if (onboardingTour?.isActive()) {
      analytics.productTourClicked({
        userId,
        initiatedTimestamp: initiatedTimestamp ?? '',
        timeStamp: dayjs().toISOString(),
        stepNumber: 19,
        clickTarget: 'Dashboard Navigation',
      })
      onboardingTour?.next()
    }
    navigate(Path.Dashboard)
  }

  const lightLogo = activeCampaign?.sponsorshipImages?.find(
    (i) => i.name === SponsorshipImageName.BannerLogo
  )
  const darkLogo = activeCampaign?.sponsorshipImages?.find(
    (i) => i.name === SponsorshipImageName.DarkModeBannerLogo
  )
  const campaignLogo = isDarkMode && darkLogo ? darkLogo : lightLogo

  return (
    <Box
      className={clsx(classes.dashNav, 'shepherd-playvs-logo')}
      ml={-2}
      mt={campaignLogo ? 2 : 6}
      onClick={navigateToDashboard}
    >
      <Box display="flex" flexDirection="column">
        {campaignLogo ? (
          <Box alignItems="center" display="flex" flexDirection="column">
            <img
              alt="campaign-logo"
              className={classes.campaignLogo}
              data-testid="campaign-logo"
              src={campaignLogo.url}
            />
          </Box>
        ) : (
          <OrgTypeLogo
            competitionGroup={orgCompetitionGroup}
            isDarkMode={isDarkMode}
          />
        )}
      </Box>
    </Box>
  )
})
